import styled from 'styled-components';

export const MobileFooterContainer = styled.div`
  & > div.logout-btn {
    width: 100%;
    text-align: center;

    & > button {
      font-size: 13px;
      margin: 5px 0px;
      width: 100%;
      background: #d4190b;
      color: #fff;
    }
  }
  & > table {
    width: 100%;
    text-align: center;
    font-size: 10px;
    height: 14vh;
    line-height: 2.5vh;

    & > thead > tr {
      border: 1px solid black;

      & > td.working-time-title { width: 50%; border-right: 1px solid black;}
      & > td.legend-title { width: 50%;}
    }

    & > tbody > tr > td {
      border: 1px solid black;
      width: 25vw;

      & > img { width: 1vh; }
    }
  }
`